module.exports = __webpack_public_path__ + "media/balcony.ebbc8b47.mp4";